<div class="container-fluid">
  <div class="profile-header" *ngIf="userDetail">
    <div class="profile-header__container">
      <div class="profile-header__info">
        <img
          class="profile-header__avatar"
          [src]="userDetail.profilePicture ? fileDirectoriesPath + userDetail.profilePicture : 'assets/images/img_profile.png'"
          alt="User Avatar"
        />
        <div class="profile-header__details">
          <h2 class="profile-header__name">
            <span> {{ userDetail?.name || 'user' }}</span>
            <!-- class="badge" -->
            <img
              *ngIf="currentUserRank?.userLevel"
              class="leaderboard__level-icon"
              [src]="'../../../assets/images/levels/ic_' + formatLevel(currentUserRank?.userLevel, false) + '_white.svg'"
              [alt]="currentUserRank?.userLevel"
              placement="bottom"
              ngbTooltip="{{ currentUserRank?.userLevel == 'xxtreme' ? 'XXtreme' : (currentUserRank?.userLevel | titlecase) }}"
              tooltipClass="customtooltip"
              container="body"
            />
          </h2>
          <div class="profile-header__tags">
            <span
              class="profile-header__tag"
              *ngFor="let sport of currentUserRank?.sports ? (currentUserRank?.sports || []).slice(0, 3) : currentUserRank?.sports || []"
              >{{ sport }}</span
            >
            <span
              *ngIf="(currentUserRank?.sports || []).length > 3"
              class="plusCount ml-2 handPointer profile-header__tag"
              placement="bottom"
              [ngbTooltip]="tipContentbanner"
              tooltipClass="customtooltip"
              container="body"
            >
              +{{ (currentUserRank?.sports || [])?.length - 3 }}
            </span>

            <ng-template #tipContentbanner>
              <!--  ngbTooltip="{{ (currentUserRank?.sports || []).join(',') }}" -->
              <div *ngFor="let sport of currentUserRank.sports">{{ sport }}</div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="profile-header__points">
        <span class="profile-header__points-value">{{ userDetail.totalScore ? (userDetail.totalScore | number: '1.0-0') : 0 }} Points</span>
        <br />
        <a (click)="showScoring()" class="profile-header__points-link">How points system works?</a>
      </div>
    </div>
  </div>
  <section class="leaderboard">
    <div class="leaderboard__Head">
      <h2 class="leaderboard__title">XDGE Leaderboard</h2>
      <button
        class="leaderboard__filter filterBox"
        (click)="openFilterPopup()"
        [class.filterApplied]="appliedFilters.length > 0 || (this.range && this.range?.clear == false)"
      >
        <!-- <img src="../../../../../assets/images/ic_filter.svg" alt="filter icon" />  -->
        <div [innerHTML]="ICONS.filterIcon | safeHtml"></div>
        Filters
      </button>
    </div>
    <div class="customTableResponsive">
      <table class="leaderboard__table">
        <thead class="leaderboard__head">
          <tr class="leaderboard__row">
            <th class="leaderboard__heading">Rank</th>
            <th class="leaderboard__heading">Name</th>
            <th class="leaderboard__heading">Points</th>
            <th class="leaderboard__heading">Level</th>
            <th class="leaderboard__heading">Sports performed</th>
          </tr>
        </thead>
        <tbody class="leaderboard__body">
          <tr class="leaderboard__row leaderboard__row--highlight" *ngIf="currentUserRank && userDetail">
            <td class="leaderboard__data" (click)="userSearch(currentUserRank)">
              <span class="rank" *ngIf="currentUserRank.rank != 1 && currentUserRank.rank != 2 && currentUserRank.rank != 3">{{
                '#' + currentUserRank.rank
              }}</span>
              <!-- {{(currentUserRank.rank!=1 && currentUserRank.rank!=2 && currentUserRank.rank!=3)?('#'+currentUserRank.rank):''}} -->
              <img
                *ngIf="currentUserRank.rank == 1 || currentUserRank.rank == 2 || currentUserRank.rank == 3"
                [src]="'../../../assets/images/ic_' + currentUserRank.rank + '.svg'"
              />
            </td>
            <td class="leaderboard__data ellipsis" (click)="userSearch(currentUserRank)">
              <img
                class="leaderboard__avatar"
                [src]="currentUserRank.profilePicture ? fileDirectoriesPath + currentUserRank.profilePicture : 'assets/images/img_profile.png'"
                alt="User Avatar"
              />
              {{ currentUserRank.name }}
              <span class="leaderboard__badge">You</span>
            </td>
            <td class="leaderboard__data">{{ currentUserRank.totalScore ? (currentUserRank.totalScore | number: '1.0-0') : 0 }} Points</td>
            <td class="leaderboard__data">
              <img
                *ngIf="currentUserRank.userLevel"
                class="leaderboard__level-icon"
                [src]="'../../../assets/images/levels/ic_' + formatLevel(currentUserRank?.userLevel, false) + '.svg'"
                [alt]="currentUserRank?.userLevel"
                placement="bottom"
                ngbTooltip="{{ currentUserRank.userLevel == 'xxtreme' ? 'XXtreme' : (currentUserRank.userLevel | titlecase) }}"
                tooltipClass="customtooltip"
                container="body"
              />
            </td>
            <td class="leaderboard__data">
              <span *ngFor="let sport of currentUserRank.sports ? currentUserRank.sports.slice(0, 2) : currentUserRank.sports; let i = index">{{
                sport + (currentUserRank.sports.length > 1 && i == 0 ? ', ' : '')
              }}</span>
              <span
                *ngIf="currentUserRank.sports.length > 2"
                class="leaderboard__extra ml-2 handPointer"
                placement="bottom"
                tooltipClass="customtooltip"
                container="body"
                [ngbTooltip]="tipContent"
              >
                +{{ currentUserRank.sports?.length - 2 }}
              </span>
              <ng-template #tipContent>
                <!--  ngbTooltip="{{ currentUserRank.sports.join(', ') }}" -->
                <div *ngFor="let sport of currentUserRank.sports">{{ sport }}</div>
              </ng-template>
            </td>
          </tr>
          <tr class="leaderboard__row" *ngFor="let data of leaderBoard">
            <td class="leaderboard__data" (click)="userSearch(data)">
              <span *ngIf="data.rank != 1 && data.rank != 2 && data.rank != 3" class="rank">{{ data.rank }}</span>

              <img *ngIf="data.rank == 1 || data.rank == 2 || data.rank == 3" [src]="'../../../assets/images/ic_' + data.rank + '.svg'" />
            </td>
            <td class="leaderboard__data ellipsis" (click)="userSearch(data)">
              <img
                class="leaderboard__avatar"
                [src]="data.profilePicture ? fileDirectoriesPath + data.profilePicture : 'assets/images/img_profile.png'"
                alt="User Avatar"
              />
              {{ data.name || 'User' }}
            </td>
            <td class="leaderboard__data">{{ data?.totalScore ? (data.totalScore | number: '1.0-0') : 0 }} Points</td>
            <td class="leaderboard__data">
              <img
                *ngIf="data?.userLevel"
                class="leaderboard__level-icon"
                [src]="'../../../assets/images/levels/ic_' + formatLevel(data?.userLevel, false) + '.svg'"
                [alt]="data?.userLevel"
                placement="bottom"
                ngbTooltip="{{ data?.userLevel == 'xxtreme' ? 'XXtreme' : (data?.userLevel | titlecase) }}"
                tooltipClass="customtooltip"
                container="body"
              />
            </td>
            <td class="leaderboard__data">
              <span *ngFor="let sport of data.sports ? data.sports.slice(0, 2) : data.sports; let i = index">{{
                sport + (data.sports.length > 1 && i == 0 ? ', ' : '')
              }}</span>
              <span
                *ngIf="data.sports.length > 2"
                class="leaderboard__extra ml-2 handPointer"
                placement="bottom"
                tooltipClass="customtooltip"
                container="body"
                [ngbTooltip]="tipContent2"
              >
                +{{ data.sports?.length - 2 }}
              </span>
              <ng-template #tipContent2>
                <!-- ngbTooltip="{{ data.sports.join(', ') }}" -->
                <div *ngFor="let sport of data.sports">{{ sport }}</div>
              </ng-template>
            </td>
          </tr>
          <!-- Repeat rows -->
        </tbody>
      </table>
    </div>
    <div class="searchResult" *ngIf="leaderBoard?.length == 0 && !currentUserRank">
      <div class="searching text-center">
        <h5>{{ pagination.text }}</h5>
      </div>
    </div>
  </section>
</div>
